import { z } from 'zod'
import {
  errorDataSchema,
  eventDataSchema,
  userDataSchema,
  zodLoginMethodEnum,
} from '../../common.schema'

export const SignUpFailureSchema = z.object({
  event: z.literal('sign_up_failure'),

  user_data: userDataSchema.extend({
    login_method: zodLoginMethodEnum,
  }),
  event_data: eventDataSchema,
  error_data: errorDataSchema,
})

export type SignUpFailureEvent = z.infer<typeof SignUpFailureSchema>
